import api from "../../utils/api/api.utils";
import { appendFilter } from "../../utils/api.utils";
export var getCards = function (filter) {
    return api.get(appendFilter("/cards", filter));
};
export var closeCard = function (id) { return api.post("/cards/".concat(id, "/close")); };
